"use client";

import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

// Tiny client component whose only job is to fire pricing_viewed once when the
// pricing page mounts. Keeping it separate preserves the Server Component
// rendering of the pricing page itself.
export default function PricingPageview() {
  const posthog = usePostHog();
  useEffect(() => {
    posthog?.capture("pricing_viewed");
  }, [posthog]);
  return null;
}
